import React from "react";
import "../assets/Css/footer.css";
import "../index.css"
export default function Footer() {
  return (
    <>
      <div className="footer-wrapper">
        <div className="footer-container page-width">
          <div className="footer-caption-cont">
            <div className="footer-caption">
              <p>Talk to us</p>
            </div>
            <div className="footer-email">
              <h1 href="mailto:someone@example.com">
                <a>customersupport@xebrand.in</a>
              </h1>
            </div>
          </div>

          <div className="footer-links">
            <div className="footer-container-1">
              {/* <div className="fot-cont">
                <ul>
                  <li>
                    <a id="top" href="#">Agency</a>
                  </li>
                  <li>
                    <a href="#">Projects</a>
                  </li>
                  <li>
                    <a href="#">Team</a>
                  </li>
                  <li>
                    <a href="#">Approach</a>
                  </li>
                  <li>
                    <a href="#">Inshights</a>
                  </li>
                  <li>
                    <a href="#">Hire Us</a>
                  </li>
                </ul>
              </div> */}

              {/* <div className="fot-cont">
                <ul>
                  <li>
                    <a id="top" href="#">Solutions</a>
                  </li>
                  <li>
                    <a href="#">Websites</a>
                  </li>
                  <li>
                    <a href="#">Ecommerce</a>
                  </li>
                  <li>
                    <a href="#">Custom software</a>
                  </li>
                  <li>
                    <a href="#">Branding</a>
                  </li>
                  <li>
                    <a href="#">PPC</a>
                  </li>
                  <li>
                    <a href="#">SEO</a>
                  </li>
                </ul>
              </div> */}
            </div>
            {/* <div className="footer-container-2">
              <div className="footer-cont1">
                <h2>Xebrand</h2>
              </div>
              <div className="foot-cont2">
                <div className="foot-tagline">
                  <p>A full-service digital marketing agency</p>
                </div>
                <div className="foot-address">
                  <p>
                    Offices at 777 Nayagaon Kumao colony.
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
